import { FontIcon, Icon } from "@fluentui/react";
import { Dropdown } from "antd";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import "./UploadButton.css";
import {
  closeUploadModal,
  openUploadModal,
} from "../../../../redux/Transcribe/TranscribeAction";
import UploadModal from "../../../SharedComponent/ModalComponent/UploadModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

const UploadButton = (props: any) => {
  const uploadModalState = useSelector(
    (state: RootState) => state.TranscribeState.uploadModalState
  );
  const dispatch = useAppDispatch();

  return (
    <>
      <button
        className="upload-btn"
        onClick={() => {
          dispatch(openUploadModal());
        }}
      >
        <span style={{ marginRight: 6 }}>
          <Icon iconName="Upload" />
        </span>
        Upload
      </button>
      <UploadModal
        openState={uploadModalState}
        open={() => dispatch(openUploadModal())}
        close={() => dispatch(closeUploadModal())}
      />
    </>
  );
};

export default UploadButton;
